import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/explore/products")({
  validateSearch: (search: Record<string, unknown>): {
    searchTerm?: string
    companyFilters?: string
    productFilters?: string
  } => ({
    searchTerm: (search.searchTerm as string) || undefined,
    companyFilters: (search.companyFilters as string) || undefined,
    productFilters: (search.productFilters as string) || undefined,
  }),
})